module.exports = __webpack_public_path__ + "img/facade-hamptons-double.e30b0d93.jpeg";